import { HttpClient } from '@angular/common/http';
import { Component, Inject, ViewChild } from '@angular/core';
import { StudentSearchService } from "../../Services/StudentSearchService";
import { IStudentSearchResult } from '../../Models/IStudentSearchResult'
import { StudentService } from "../../Services/StudentService";
import { ISelectedStudent } from '../../Models/ISelectedStudent'
import { DashboardDocumentService } from "../../Services/DashboardDocumentService";
import { IDashboardDocument } from '../../Models/IDashboardDocument';
import { ICanAddDocuments } from '../../Models/ICanAddDocuments';
import { Globals } from '../../globals'

@Component({
  selector: 'SupportingWindowToggler',
  templateUrl: './SupportingWindowToggler.component.html',
})
export class SupportingWindowTogglerComponent {
  _http: HttpClient;
  _myGlobals: Globals;

  constructor(
    http: HttpClient,
    private globals: Globals) {
    this._http = http;
    this._myGlobals = globals;
  }

  showDocumentDashboard() {
    this._myGlobals.documentDashboardIsVisible = true;
  }

  hideDocumentDashboard() {
    this._myGlobals.documentDashboardIsVisible = false;
  }

  showInitialIEPInfo() {
    this._myGlobals.initialIepInfoIsVisible = true;
  }

  hideInitialIEPInfo() {
    this._myGlobals.initialIepInfoIsVisible = false;
  }

  showEnrollment() {
    this._myGlobals.studentEnrollmentsIsVisible = true;
  }

  hideEnrollment() {
    this._myGlobals.studentEnrollmentsIsVisible = false;
  }

}
